export default __webpack_public_path__ + "static/media/OGR_Login_logo.3721f461.png";